// extracted by mini-css-extract-plugin
export default {"input":"input_input__EBh3D","errorIn":"input_errorIn__icjfZ","main":"input_main__GrgEz","inputDiv":"input_inputDiv__TOaN4"};